/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_ProofInputs */

const vi_tea_purchase_payment_proof = /** @type {(inputs: Tea_Purchase_Payment_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh bill chuyển khoản`)
};

/**

* @param {Tea_Purchase_Payment_ProofInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_proof = /** @type {((inputs?: Tea_Purchase_Payment_ProofInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_ProofInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_proof(inputs)
});